import { useEffect, useState } from 'react';
import AnimationLogo from '../Utils/AnimationLogo';

const logoSize = () => Math.min(window.innerWidth * 0.35, window.innerHeight * 0.35, 360);

export default function WelcomeScreen({ onReady }) {
  const [size, setSize] = useState(logoSize);

  useEffect(() => {
    const onResize = () => setSize(logoSize());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleBuildComplete = () => {
    setTimeout(() => onReady?.(), 800);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
        background: '#000',
      }}
    >
      <AnimationLogo
        size={size}
        stepDuration={250}
        delay={0.3}
        bgColor="transparent"
        onBuildComplete={handleBuildComplete}
      />
    </div>
  );
}
